// vim: set ts=2 sts=2 sw=2 et:

import { PlatformLiveProfile } from "./platformLiveProfile";
import type { PlatformLiveBridgeProviderId } from "./platformLiveBridgeClient";
import type { RecordMarkingMode } from "../records/recordMarkingPolicy";
import type { WrpfRecordCategory } from "../handoff/types";

export type WrpfLiveAction =
  | {
      readonly type: "ACTIVATE_PLATFORM_LIVE_PROFILE";
      readonly profile: PlatformLiveProfile;
    }
  | {
      readonly type: "DEACTIVATE_PLATFORM_LIVE_PROFILE";
    }
  | {
      readonly type: "CLEAR_HELPER_PROFILE_CANDIDATE";
    }
  | {
      readonly type: "SET_RECORD_MARKING_MODE";
      readonly mode: RecordMarkingMode;
    }
  | {
      readonly type: "SET_RECORD_TEST_TOOLS_ENABLED";
      readonly enabled: boolean;
    }
  | {
      readonly type: "SET_REGISTRATION_PAGINATION_ENABLED";
      readonly enabled: boolean;
    }
  | {
      readonly type: "SET_PLATFORM_LIVE_BRIDGE_PROVIDER";
      readonly providerId: PlatformLiveBridgeProviderId;
    }
  | {
      readonly type: "SET_RECORD_ATTEMPT_OVERRIDE";
      readonly attemptKey: string;
      readonly category: WrpfRecordCategory | false;
    }
  | {
      readonly type: "CLEAR_RECORD_ATTEMPT_OVERRIDE";
      readonly attemptKey: string;
    }
  | {
      readonly type: "CAPTURE_RESOLVED_RECORD_ATTEMPT";
      readonly attemptKey: string;
      readonly category: WrpfRecordCategory | undefined;
    };

export const activatePlatformLiveProfile = (profile: PlatformLiveProfile): WrpfLiveAction => ({
  type: "ACTIVATE_PLATFORM_LIVE_PROFILE",
  profile,
});

export const deactivatePlatformLiveProfile = (): WrpfLiveAction => ({
  type: "DEACTIVATE_PLATFORM_LIVE_PROFILE",
});

export const clearHelperProfileCandidate = (): WrpfLiveAction => ({
  type: "CLEAR_HELPER_PROFILE_CANDIDATE",
});

export const setRecordMarkingMode = (mode: RecordMarkingMode): WrpfLiveAction => ({
  type: "SET_RECORD_MARKING_MODE",
  mode,
});

export const setRecordTestToolsEnabled = (enabled: boolean): WrpfLiveAction => ({
  type: "SET_RECORD_TEST_TOOLS_ENABLED",
  enabled,
});

export const setRegistrationPaginationEnabled = (enabled: boolean): WrpfLiveAction => ({
  type: "SET_REGISTRATION_PAGINATION_ENABLED",
  enabled,
});

export const setPlatformLiveBridgeProvider = (providerId: PlatformLiveBridgeProviderId): WrpfLiveAction => ({
  type: "SET_PLATFORM_LIVE_BRIDGE_PROVIDER",
  providerId,
});

export const setRecordAttemptOverride = (attemptKey: string, category: WrpfRecordCategory | false): WrpfLiveAction => ({
  type: "SET_RECORD_ATTEMPT_OVERRIDE",
  attemptKey,
  category,
});

export const clearRecordAttemptOverride = (attemptKey: string): WrpfLiveAction => ({
  type: "CLEAR_RECORD_ATTEMPT_OVERRIDE",
  attemptKey,
});

export const captureResolvedRecordAttempt = (
  attemptKey: string,
  category: WrpfRecordCategory | undefined,
): WrpfLiveAction => ({
  type: "CAPTURE_RESOLVED_RECORD_ATTEMPT",
  attemptKey,
  category,
});
